import { NodeData } from "./nodeData";
import {StyleLine, StyleShape, TypeLine} from '../types';

export const ProjectData = {
    name: "",
    description: "",
    ispublic: false,
    allowcomments: false,
    owner: "",
    defaultshapetype: StyleShape[0].value,
    defaultedgetype: StyleLine[0].value,
    defaultconnectiontype: TypeLine[0].value,
    createdon: new Date('1995-12-17T03:24:00'),
    elements: [],
}